// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  configProduct = 'configProduct',
}

// eslint-disable-next-line no-shadow
export enum FormInputName {
  section = 'section',
  imageBase64Sector = 'imageBase64Sector',
}

export interface NameFiles {
  [key: string]: string;
}

export interface EventProduct {
  id: string;
  name: string;
  checked: boolean;
}

export interface SectionSubGroup {
  categorySubGroupId: string;
  categorySubGroupName: string;
  products: EventProduct[];
  combos: EventProduct[];
  checked: boolean;
}

export interface SectionGroup {
  categoryGroupId: string;
  categoryGroupName: string;
  subGroups: SectionSubGroup[];
}
